import { createSlice } from '@reduxjs/toolkit';

import { Alert } from 'entities/Alert';
import { AppError } from 'entities/Errors';

import { getAlertList, updateAlert } from './alert.action';

interface AlertState {
  action: 'idle' | 'list' | 'update' | 'refresh';
  status: 'idle' | 'loading' | 'failed' | 'successed';
  error: null | AppError;
  alertList: Alert[];
}

const initialState: AlertState = {
  action: 'idle',
  status: 'idle',
  alertList: [],
  error: null,
};

export const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    refresh: (state) => {
      state.error = null;
      state.action = 'idle';
      state.status = 'idle';
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getAlertList.pending, (state) => {
        state.action = 'list';
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getAlertList.fulfilled, (state, action) => {
        state.status = 'successed';
        state.alertList = action.payload.data;
      })
      .addCase(getAlertList.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as AppError;
      })
      .addCase(updateAlert.pending, (state) => {
        state.status = 'loading';
        state.action = 'update';
        state.error = null;
      })
      .addCase(updateAlert.fulfilled, (state, action) => {
        state.status = 'successed';
        state.alertList = state.alertList.filter(
          (x) => x.id !== action.payload.data.id
        );
      })
      .addCase(updateAlert.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as AppError;
      });
  },
});

export const { refresh: alertRefresh } = alertSlice.actions;

export default alertSlice.reducer;
